import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import MediumButton from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/MediumButton"
import { observer } from "mobx-react"
import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router"

interface Props {
	mobileView?: boolean
}

const ConfigButton = observer(({ mobileView = false }: Props) => {
	const store = useStore()
	const { t } = useTranslation()
	const history = useHistory()
	const formStore = useFormStore()
	const ptkmStore = usePTKMStore()
	const location = useLocation()

	const formSection = location.pathname.includes(ROUTES.FORM_CONFIGURATION)
	const ptkmSection = location.pathname.includes(ROUTES.PTKM_CONFIGURATION)

	const openConfigurationSection = () => {
		if (ptkmSection) {
			history.push(ROUTES.PTKM)
		} else {
			history.push(ROUTES.REQUEST_CNFG)
		}
	}

	const _onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		const hasUnsavedChanges = !formStore.checkIfFormIsEdited() || !ptkmStore.checkIfFormIsEdited()
		const isInConfigSection = formSection || ptkmSection
		
		if (isInConfigSection && hasUnsavedChanges) {
			store.setInfoModalConfig({
				type: "warning",
				titleKey: "",
				descriptionKey: t("rawText.save-all-changes"),
				proceedTextKey: t("button.continue"),
				onProceed: () => openConfigurationSection(),
				showCancelBtn: true,
				cancelTextKey: t("rawText.back"),
				onCancel: () => store.resetInfoModalConfig(),
			})
		} else {
			openConfigurationSection()
		}
	}

	return (
		<MediumButton
			style={{
				color: mobileView
					? "var(--muddy-puddle-gray)"
					: formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)",
				background: "none",
				fontSize: mobileView ? "12px" : "14px",
				fontWeight: mobileView ? 400 : 600,
			}}
			borderless
			onClick={_onClick}
			children={t("rawText.configuration")}
		/>
	)
})

export default ConfigButton
